// Mock data for Maison Élégance Restaurant

export const restaurantInfo = {
  name: "Maison Élégance",
  tagline: "An Evening of Culinary Indulgence",
  description: "Experience fine dining where every detail is a celebration of flavor.",
  phone: "+1 (555) 123-4567",
  email: "reservations@maisonelegance.com",
  address: "123 Gourmet Avenue, Culinary District, New York, NY 10001",
  hours: {
    monday: "Closed",
    tuesday: "5:00 PM - 10:00 PM",
    wednesday: "5:00 PM - 10:00 PM", 
    thursday: "5:00 PM - 10:00 PM",
    friday: "5:00 PM - 11:00 PM",
    saturday: "5:00 PM - 11:00 PM",
    sunday: "5:00 PM - 9:00 PM"
  }
};

export const menuData = {
  starters: [
    {
      name: "Oysters Rockefeller",
      description: "Fresh Blue Point oysters with creamed spinach, herbs, and a touch of Pernod",
      price: "$18"
    },
    {
      name: "Foie Gras Terrine",
      description: "House-made terrine with Sauternes gelée and toasted brioche",
      price: "$28"
    },
    {
      name: "Burrata & Prosciutto",
      description: "Creamy burrata with aged Prosciutto di Parma and fig compote",
      price: "$22"
    },
    {
      name: "Lobster Bisque",
      description: "Classic French bisque with Maine lobster and a splash of cognac",
      price: "$16"
    }
  ],
  entrees: [
    {
      name: "Beef Wellington",
      description: "Prime beef tenderloin wrapped in puff pastry with mushroom duxelles",
      price: "$65"
    },
    {
      name: "Dover Sole Meunière",
      description: "Whole Dover sole with brown butter, capers, and fresh herbs",
      price: "$58"
    },
    {
      name: "Rack of Lamb",
      description: "Herb-crusted Colorado lamb with rosemary jus and roasted vegetables",
      price: "$52"
    },
    {
      name: "Bouillabaisse Marseillaise",
      description: "Traditional Provençal fish stew with saffron rouille",
      price: "$48"
    },
    {
      name: "Duck Confit",
      description: "Slow-cooked duck leg with cherry gastrique and potato galette",
      price: "$42"
    }
  ],
  desserts: [
    {
      name: "Chocolate Soufflé",
      description: "Dark chocolate soufflé with vanilla bean crème anglaise",
      price: "$14"
    },
    {
      name: "Crème Brûlée",
      description: "Classic vanilla custard with caramelized sugar",
      price: "$12"
    },
    {
      name: "Tarte Tatin",
      description: "Upside-down apple tart with Calvados ice cream",
      price: "$13"
    },
    {
      name: "Profiteroles",
      description: "Choux pastry filled with vanilla ice cream and warm chocolate sauce",
      price: "$11"
    }
  ],
  wines: [
    {
      name: "Château Margaux 2015",
      description: "Bordeaux, France - Full-bodied red with exceptional depth",
      price: "$450"
    },
    {
      name: "Dom Pérignon 2012",
      description: "Champagne, France - Elegant bubbles with notes of citrus and brioche",
      price: "$280"
    },
    {
      name: "Chablis Premier Cru 2020",
      description: "Burgundy, France - Crisp white with mineral complexity",
      price: "$85"
    },
    {
      name: "Barolo Brunate 2018",
      description: "Piedmont, Italy - Rich and powerful with truffle notes",
      price: "$120"
    }
  ]
};

export const testimonials = [
  {
    id: 1,
    text: "Maison Élégance turned dinner into an unforgettable evening. Every course was a masterpiece, and the wine pairing was absolutely divine. Five stars.",
    author: "Isabelle M.",
    location: "Manhattan"
  },
  {
    id: 2,
    text: "The attention to detail is extraordinary. From the moment we walked in until dessert, every aspect exceeded our expectations. The best dining experience in the city.",
    author: "James R.",
    location: "Brooklyn"
  },
  {
    id: 3,
    text: "Exceptional cuisine in an elegant atmosphere. The staff's knowledge and service were impeccable. We'll definitely be returning for our anniversary.",
    author: "Maria & Carlos S.",
    location: "Queens"
  }
];

export const galleryImages = [
  {
    id: 1,
    src: "https://images.unsplash.com/photo-1559339352-11d035aa65de?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    alt: "Elegant plated gourmet dish",
    title: "Signature Beef Wellington"
  },
  {
    id: 2,
    src: "https://images.unsplash.com/photo-1510812431401-41d2bd2722f3?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", 
    alt: "Wine being poured at candlelit table",
    title: "Curated Wine Selection"
  },
  {
    id: 3,
    src: "https://images.unsplash.com/photo-1424847651672-bf20a4b0982b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    alt: "Elegant restaurant interior",
    title: "Intimate Dining Atmosphere"
  },
  {
    id: 4,
    src: "https://images.unsplash.com/photo-1587899897387-091ebd01a6b2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    alt: "Chef presenting dessert",
    title: "Artisanal Desserts"
  },
  {
    id: 5,
    src: "https://images.unsplash.com/photo-1551218808-94e220e084d2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    alt: "Raw oysters on ice",
    title: "Fresh Seafood Selection"
  },
  {
    id: 6,
    src: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    alt: "Candlelit dining room",
    title: "Romantic Evening Setting"
  }
];

export const heroImages = {
  main: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80",
  about: "https://images.unsplash.com/photo-1577219491135-ce391730fb2c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
  cta: "https://images.unsplash.com/photo-1558618047-3c8c76ca7d13?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80"
};